import { useState, useEffect } from "react";
import listText from "../utils/dictionaries/dictionary-information-requirements";
import Paragraph from "../components/atoms/paragraph";
import Accordion from "../components/organisms/accordion";
import Checkbox from "../components/molecules/checkbox";
import { linksItems } from "../utils/ir-functions";
import LinkList from "../components/templates/link-list";
import { useNavigate } from "react-router-dom";
import InformationTextUtilService from "../services/informationTextUtil.service";
import { GeneralInformationTextUseCase } from "../../application/use-cases/generalInformationText.usecase";
import Loader from "../components/atoms/loader";
import AcceptAuthorizeUtilService from "../services/acceptAuthorizeUtil.service";
import { classAcceptAuthorizeUseCase } from "../../application/use-cases/acceptAuthorize.usecase";
import MessagesReactModal from "../components/templates/messages-react-modal";
import hexagonExclamationThin from "../assets/icons/hexagon-exclamation-thin.svg";
import ic_xclose from "../assets/icons/ic_xclose.svg";
import Top from "../components/templates/top";
import Link from "../components/atoms/link";
import DocsUtilService from "../services/docsUtil.service";
import { DocsUseCase } from "../../application/use-cases/docs.usecase";
import Button from "../components/atoms/button";
import { store } from "../redux/store";
import { useFollowLater } from "../hooks/useFollowLater";

const InformationRequirements = () => {
  const { onClickContinue } = useFollowLater();
  const state = store.getState();
  const [btnColor, setBtnColor] = useState("button-disabled");
  const [checked, setChecked] = useState(false);
  const [enabledButton, setEnabledButton] = useState(true);
  const [incompleteData, setIncompleteData] = useState(true);
  const [informationList, setInformationList] = useState([]);
  const [somethingWentWrong, setSomethingWentWrong] = useState(true);
  const [activeSpinner, setActiveSpinner] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const caseService = new InformationTextUtilService();
  const useCase = new GeneralInformationTextUseCase(caseService);

  const caseServiceAutorice = new AcceptAuthorizeUtilService();
  const useCaseAutorize = new classAcceptAuthorizeUseCase(caseServiceAutorice);

  const caseDocs = new DocsUtilService();
  const useCaseDocs = new DocsUseCase(caseDocs);

  const acceptAuthorize = (value: boolean) => {
    if (!somethingWentWrong) {
      setChecked(!value);
      setBtnColor(value ? "button-disabled" : "button-enabled");
      setEnabledButton(value);
    }
  };
  const navigate = useNavigate();
  const levelRout = async () => {
    setActiveSpinner(true);
    const response = await useCaseAutorize.termsConditionsAutorize(state.client.clientPersist.uuid);
    if (response.error != null) {
      setModalShow(true);
    } else {
      onClickContinue({
        data: {},
        processId: state.client.clientPersist.uuid,
        resource: "InformationRequeriments",
        step: "CONTINUE",
      });
      navigate("/AccountOpening");
    }
    setActiveSpinner(false);
  };
  const functionProcessModal = () => {
    setModalShow(false);
    window.location.replace("");
  };
  useEffect(() => {
    const getInformation = async () => {
      setIncompleteData(true);
      const response = await useCase.informationText();
      if (response.error === null) {
        setSomethingWentWrong(false);
      } else {
        setModalShow(true);
      }
      setInformationList(response.data);
      setIncompleteData(false);
    };
    getInformation();
  }, []);

  useEffect(() => {
    const getDocumentsUrl = async () => {
      const resDocDigitalCOntract = await useCaseDocs.getDigitalContractDoc();
      const resDocCaratylaInversion = await useCaseDocs.getCaratulaInversionesDoc();
      if (resDocDigitalCOntract.error != null || resDocCaratylaInversion.error != null) {
        setModalShow(true);
      }
    };
    getDocumentsUrl();
  }, []);

  const followLaterAction = () => {
    navigate("/FollowLater", {
      state: {
        processId: state.client.clientPersist.uuid,
        resource: "InformationRequeriments",
        step: "CONTINUE_AFTER",
        data: {}, //Agregar data del formulario
      },
    });
  };

  return (
    <>
      {incompleteData ? (
        <Loader />
      ) : (
        <>
          <div className="content-container">
            <Top
              titleHeader={"Apertura de cuenta"}
              subTitle={"¡Gracias por elegirnos!"}
              displayProgressBar={"d-none"}
              displayLeftImageTitle={"d-none"}
              classTitleImage={""}
              classHeader={"mt-2 mb-3"}
              styleHeader={{}}
              classProgressBar={"mt-3"}
              styleProgressBar={{}}
              classTitleAndImage={""}
              styleTitleAndImage={{}}
              valueProgressBar={""}
              comeFrom={"/InformationRequirements"}
              onClickGoBackIcon={undefined}
            />
            <div className="p-3">
              <div className="my-2">
                <Paragraph
                  text={listText.text_2.mainText}
                  className={"fs-6"}
                  styleParagraph={undefined}
                />
              </div>
              <div className="mb-3">
                <Accordion accordionItems={informationList} listType={"information"} />
              </div>
              <div className="mt-4">
                <LinkList dataItems={linksItems} />
              </div>
              <div className="mt-5">
                <Checkbox
                  text={listText.text_22.mainText}
                  htmlFor={"flexCheckDefault"}
                  classNameLabel={"fs-6"}
                  classCheckbox={"form-check my-4_2"}
                  checked={checked}
                  onChange={() => {
                    acceptAuthorize(checked);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="footer--pin">
            <Button
              text={listText.text_23.mainText}
              divClassName={"d-grid gap-2 "}
              buttonClassName={`${btnColor} ${
                activeSpinner ? "pe-none" : ""
              } w-100 place-content-center align-self-center`}
              spinner={activeSpinner}
              onClick={() => {
                levelRout();
              }}
              disabled={enabledButton}
              dataBsDismiss={undefined}
            />

            <div className="text-center mt-3">
              <Link
                text={"Seguir más tarde"}
                url={null}
                styleLink={{
                  color: "#5A6172",
                  lineHeight: "16px",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                onClick={() => followLaterAction()}
                className={""}
              />
            </div>
          </div>
          <p style={{ width: "100%", textAlign: "center", color: "rgb(90, 97, 114)", fontSize: 9 }}>
            {"v0.0.06-alpha"}
          </p>
        </>
      )}
      <MessagesReactModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textTitle={listText.text_24.mainText}
        classTitle={"fw-bold"}
        styleTitle={{ color: "#00254A", fontSize: "20px", fontWeight: "700" }}
        listButtonsModal={[
          {
            text: listText.text_25.mainText,
            style: {},
            divClass: "",
            buttonClass: "button-enabled w-100 place-content-center align-self-center mt-3",
            spinner: false,
            onClick: () => {
              functionProcessModal();
            },
            disabled: false,
          },
        ]}
        imageModal={hexagonExclamationThin}
        onClickClose={() => setModalShow(false)}
        imageOnlyClose={ic_xclose}
        classContent={"ml-3 mr-3 mb-3 text-center"}
        classImageModal={"text-center my-4"}
        listParagraphs={[
          {
            textParagraph: listText.text_26.mainText,
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
          {
            textParagraph: listText.text_27.mainText,
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
        ]}
      />
    </>
  );
};

export default InformationRequirements;
